import DeprecatedShow from "atoms/wrappers/show";
import React from "react";

// DO NOT USE
// While this appears at first glance to be a more readable replacement for { condition && <RenderedItems />},
// it does not take advantage of the logical AND operator's (&&) short-circuiting,
// making it less performant and may unexpecteded evaluate the unrendered children, unlike &&.

export interface DeprecatedHideProps {
    when: boolean;
    fallback?: React.ReactNode;
    children?: React.ReactNode;
}

const DeprecatedHide: React.FC<DeprecatedHideProps> = ({
    when,
    fallback = <></>,
    children,
}) => {
    return (
        <DeprecatedShow children={children} fallback={fallback} when={!when} />
    );
};

export default DeprecatedHide;
